import useContentful from '../useContentful';
/** @public */
export default function useContentfulWithPredicate(fieldName, predicate) {
  const content = useContentful(fieldName);
  if (!fieldName) {
    return;
  }
  return predicate(content) ? content : undefined;
}